import { render, staticRenderFns } from "./DropdownAttachment.vue?vue&type=template&id=bafcf1e6&scoped=true"
import script from "./DropdownAttachment.vue?vue&type=script&lang=js"
export * from "./DropdownAttachment.vue?vue&type=script&lang=js"
import style0 from "./DropdownAttachment.vue?vue&type=style&index=0&id=bafcf1e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafcf1e6",
  null
  
)

export default component.exports